const comments = [
  {
    name: '墨染青衣',
    avatar: '墨',
    work: '《霸道总裁的契约恋人》读者',
    text: '真的太好看了！画风细腻，剧情不拖沓，总裁攻和设计师受的互动超级甜，熬夜追完根本停不下来。腐漫画网的阅读体验也很棒，下拉式看漫画太舒服了！',
    date: '2026-07-25',
  },
  {
    name: '樱花飘落时',
    avatar: '樱',
    work: '《樱花树下的约定》读者',
    text: '日漫腐的经典之作，校园题材永远的神。两个人从陌生到熟悉的过程刻画得非常自然，最后樱花树下那一幕直接泪目。感谢腐漫画网收录了这部宝藏作品。',
    date: '2026-07-24',
  },
  {
    name: '江湖夜雨',
    avatar: '江',
    work: '《剑影风华录》读者',
    text: '国漫耽美的古风作品越来越优秀了！这部画风完全不输韩漫，剧情格局很大，正邪对立中的感情线特别带感。腐漫画网的推荐真的靠谱，每次都能发现好作品。',
    date: '2026-07-23',
  },
  {
    name: '星月神话',
    avatar: '星',
    work: '《异世界魔王的宠妃》读者',
    text: '韩漫耽美的奇幻题材太上头了！魔王的深情人设真的绝，画面华丽到每一格都能当壁纸。腐漫画网更新速度也很快，新章节一出就能马上看到，追漫体验满分。',
    date: '2026-07-22',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            读者评价
          </h2>
          <p className="mt-2 text-sm text-foreground-500">听听腐漫爱好者们怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {comments.map((c) => (
            <div
              key={c.name}
              className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 font-bold text-sm font-heading">
                  {c.avatar}
                </div>
                <div>
                  <span className="text-sm font-semibold text-foreground-900">{c.name}</span>
                  <p className="text-xs text-foreground-400">{c.work}</p>
                </div>
              </div>
              <p className="mt-3 text-xs md:text-sm text-foreground-600 leading-relaxed">
                {c.text}
              </p>
              <span className="mt-3 inline-block text-xs text-foreground-300">{c.date}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}